import { IinitialGoogleAddressState } from 'interfaces/googleAddress.interface';

const initialGoogleAddressState: IinitialGoogleAddressState = {
  googleAddresses: [
    {
      formKey: 'main',
      address: '',
      postal_code: '',
      country_id: '',
      city: '',
      province: '',
      floor: '',
      door: '',
      coordinates: {
        lat: 0,
        lng: 0,
      },
    },
  ],
  setGoogleAddress: () => {},
  autoSetGoogleAddress: () => {},
  resetGoogleAddress: () => {},
};

export default initialGoogleAddressState;
